// Psychology lessons — RE₿EL LLM pipeline translation (Sprint B).
// id keys preserved from ES.

export const LECCIONES_PSICOLOGIA = [
  {
    id: "los-7-errores",
    numero: 1,
    titulo: "Die 7 psychologischen Fehler, die Konten zerstören",
    duracion: "12 min",
    descripcion: "95% der Trader verlieren Geld. Nicht wegen mangelnder technischer Kenntnisse — sondern wegen fehlender mentaler Disziplin. Dies sind die 7 häufigsten psychologischen Fehler und wie man sie vermeidet.",
    contenido: [
      {
        tipo: "error",
        numero: 1,
        nombre: "FOMO (Fear Of Missing Out)",
        descripcion: "In einen Trade einsteigen, weil der Preis bereits stark gestiegen ist und man Angst hat, die Bewegung zu verpassen. Ergebnis: Man kauft auf Höchstständen und ist die letzte Person, die einsteigt, bevor der Preis fällt.",
        sintomas: [
          "Man steigt ohne Analyse ein",
          "Der Preis ist bereits >5% gestiegen",
          "Man hat keinen definierten SL-Plan",
          "Man verspürt Dringlichkeit"
        ],
        solucion: "Akzeptiere, dass es immer eine weitere Gelegenheit geben wird. Wenn du nicht am Anfang der Bewegung eingestiegen bist, ist der Trade NICHT MEHR DEINER. Warte auf das nächste Setup.",
        ejercicio: "Wenn du das nächste Mal FOMO verspürst, schreibe in dein Tagebuch: «Der Preis ist bereits um X% gestiegen. Wenn ich jetzt einsteige, beträgt mein R:R ___». Wenn das R:R unter 1:2 liegt, steige NICHT ein."
      },
      {
        tipo: "error",
        numero: 2,
        nombre: "Revenge Trading",
        descripcion: "Nach einem Verlust sofort einen weiteren Trade eröffnen, um das verlorene Geld zurückzugewinnen. Man handelt aus Emotionen heraus, nicht aus Strategie. Ergebnis: Der zweite Verlust ist meist größer als der erste.",
        sintomas: [
          "Man hat gerade einen Trade verloren",
          "Man steigt ohne Setup-Bestätigung ein",
          "Man erhöht die Positionsgröße",
          "Man verspürt Wut oder Frustration"
        ],
        solucion: "Unumstößliche Regel: Nach 2 aufeinanderfolgenden Verlusten STOPPE das Trading für diesen Tag. Der Markt wird morgen noch da sein.",
        ejercicio: "Implementiere die 2-Stop-Regel: Wenn du an einem Tag 2 Stop Losses aktivierst, schließe die Plattform. Ohne Ausnahmen."
      },
      {
        tipo: "error",
        numero: 3,
        nombre: "Stop Loss verschieben",
        descripcion: "Der Preis nähert sich dem Stop Loss und anstatt ihn aktivieren zu lassen, verschiebt man ihn weiter nach unten «in der Hoffnung auf Erholung». Ergebnis: Ein 1%-Verlust wird zu einem 5-10%-Verlust.",
        sintomas: [
          "Der Preis nähert sich dem SL",
          "Man denkt «nur noch ein bisschen»",
          "Man hat den SL mehr als einmal verschoben",
          "Der Trade dauert viel länger als geplant"
        ],
        solucion: "Der Stop Loss ist HEILIG. Wenn du ihn bei der Analyse an der richtigen Stelle gesetzt hast, verschiebe ihn nicht. Wenn du ihn verschiebst, wird dein gesamtes Risikomanagement nutzlos.",
        ejercicio: "Klebe einen Zettel an deinen Monitor: «SL = PLAN. PLAN = SL. NICHT VERSCHIEBEN»."
      },
      {
        tipo: "error",
        numero: 4,
        nombre: "Overtrading",
        descripcion: "Übermäßiges Trading auf der ständigen Suche nach Trades. Langeweile oder Euphorie führen dazu, dass man Setups minderer Qualität eingeht. Mehr Trades = mehr Gebühren = mehr Risikoexposition = mehr mentale Erschöpfung.",
        sintomas: [
          "Man hat mehr als 5 Trades an einem Tag",
          "Man sucht aktiv nach Trades",
          "Man wechselt Timeframes auf der Suche nach Setups",
          "Man kann nicht ohne offene Position sein"
        ],
        solucion: "Qualität vor Quantität. Definiere dein tägliches Maximum an Trades (empfohlen: 2-3). Wenn du es erreicht hast, höre auf. Die besten Trader machen wenige, aber sehr selektive Trades.",
        ejercicio: "Führe ein Register aller deiner Trades. Vergleiche am Monatsende die Win Rate der ersten Trades des Tages mit den letzten. Du wirst sehen, dass die letzten schlechter sind."
      },
      {
        tipo: "error",
        numero: 5,
        nombre: "Vor dem Take Profit aussteigen",
        descripcion: "Der Trade läuft gut, man hat +3% und entscheidet sich, vor Erreichen des TP zu schließen, weil man «schon genug gewonnen hat» oder aus Angst vor einer Umkehr. Ergebnis: Das tatsächliche R:R beträgt 1:0,8 statt 1:3.",
        sintomas: [
          "Man schließt gewinnende Trades früh",
          "Man hat Angst, dass der Gewinn verschwindet",
          "Der durchschnittliche Gewinn ist kleiner als das durchschnittliche Risiko"
        ],
        solucion: "Vertraue deiner Analyse. Wenn du den TP auf einem technisch validen Level gesetzt hast, lass ihn laufen. Du kannst Teilverkäufe nutzen (50% beim ersten Ziel schließen), um die Angst zu reduzieren.",
        ejercicio: "Notiere in deinem Tagebuch den Preis, zu dem du geschlossen hast, und den Preis, den er tatsächlich erreicht hat. Quantifiziere, wie viel du «auf dem Tisch gelassen hast», weil du den TP nicht respektiert hast."
      },
      {
        tipo: "error",
        numero: 6,
        nombre: "Übermäßiges Selbstvertrauen nach Gewinnserien",
        descripcion: "Nach 5-6 aufeinanderfolgenden gewinnenden Trades erhöht man die Positionsgröße oder senkt die Analysestandards, weil man «auf einer Gewinnserie ist». Hochmut kommt vor dem Fall. Immer.",
        sintomas: [
          "Man hat mehrere gewinnende Trades hintereinander",
          "Man erhöht die Größe ohne Begründung",
          "Man analysiert jeden Trade weniger",
          "Man fühlt sich, als «könne man nicht verlieren»"
        ],
        solucion: "Der Markt weiß nicht, dass du auf einer Gewinnserie bist. Jeder Trade ist unabhängig. Behalte immer das gleiche Risiko-% bei.",
        ejercicio: "Definiere im Voraus, wann du die Positionsgröße erhöhen wirst: nur wenn das Kapital um 20% gewachsen ist. Nicht früher."
      },
      {
        tipo: "error",
        numero: 7,
        nombre: "Den Trading-Plan nicht befolgen",
        descripcion: "Man hat einen Plan, ignoriert ihn aber im Moment des Tradings, weil «dieses Mal ist es anders». Ohne Plan = ohne Disziplin = ohne konsistente Ergebnisse. Der Plan ist kein Vorschlag, er ist das Gesetz.",
        sintomas: [
          "Man ändert die Strategie im Moment",
          "Man handelt nach Intuition",
          "Die Ergebnisse sind inkonsistent",
          "Man hat keine schriftlichen Regeln"
        ],
        solucion: "Schreibe deine Trading-Regeln auf Papier und platziere sie vor dem Monitor. Überprüfe vor jedem Trade, ob er ALLE Bedingungen erfüllt. Wenn nicht, gibt es keinen Trade.",
        ejercicio: "Schreibe jetzt sofort deinen Trading-Plan: Einstiegsbedingungen, SL, TP, maximale Trades pro Tag, maximal zu riskierendes Kapital. Eine Seite, einfache Regeln, keine Ausnahmen."
      }
    ]
  },
  {
    id: "reglas-trading-personal",
    numero: 2,
    titulo: "Wie du dein persönliches Trading-Regelwerk erstellst",
    duracion: "8 min",
    descripcion: "Ein Trader ohne Regeln ist ein Spieler. Der Unterschied zwischen einem professionellen Trader und einem Verlierer ist nicht das technische Wissen — es ist die Disziplin, unter allen Marktbedingungen einem Regelwerk zu folgen.",
    contenido_texto: "Ein Trader ohne Regeln ist ein Spieler. Der Unterschied zwischen einem professionellen Trader und einem Verlierer ist nicht das technische Wissen — es ist die Disziplin, unter allen Marktbedingungen einem Regelwerk zu folgen.\n\nDEINE REGELN MÜSSEN ENTHALTEN:\n\n1. EINSTIEGSKRITERIEN\n   «Ich steige nur ein, wenn: [liste deine spezifischen Bedingungen auf]».\n   Beispiel: «Ich steige nur bei aufwärts gerichtetem Trend (4H) ein, bei Pullback zu OB, mit CHoCH-Bestätigung auf 15m, mit minimalem R:R von 1:2».\n\n2. RISIKOMANAGEMENT\n   • Mein maximales Risiko pro Trade beträgt X%.\n   • Mein maximaler Tagesverlust beträgt X%.\n   • Wenn ich X% in der Woche verliere, trade ich diese Woche nicht mehr.\n\n3. MARKTBEDINGUNGEN\n   • Ich trade nicht 30 Minuten vor wichtigen Nachrichten.\n   • Ich trade montags nicht vor 9 Uhr.\n   • Ich trade nur während der Londoner oder New Yorker Sitzung.\n\n4. EMOTIONALES MANAGEMENT\n   • Wenn ich 2 aufeinanderfolgende Stops aktiviere, höre ich für diesen Tag auf.\n   • Ich überprüfe den Plan vor jedem Trade.\n   • Ich trade nicht, wenn ich müde, wütend oder gestresst bin.\n\n5. ÜBERPRÜFUNG UND VERBESSERUNG\n   • Jeden Sonntag überprüfe ich alle Trades der Woche.\n   • Jeden Monat berechne ich meine Statistiken: Win Rate, durchschnittliches R:R, Drawdown.\n\nDrucke deinen Plan aus. Klebe ihn dort hin, wo du ihn jeden Tag siehst. Lies ihn vor jeder Sitzung. Wenn du ihn 90 Tage lang befolgst, wirst du ein anderer Trader werden."
  },
  {
    id: "diario-emocional",
    numero: 3,
    titulo: "Das emotionale Trading-Tagebuch",
    duracion: "6 min",
    descripcion: "Die besten Trader der Welt führen ein Tagebuch. Sie registrieren nicht nur die Zahlen (Einstieg, Ausstieg, P&L), sondern auch ihren mentalen Zustand.",
    contenido_texto: "Die besten Trader der Welt führen ein Tagebuch. Sie registrieren nicht nur die Zahlen (Einstieg, Ausstieg, P&L), sondern auch ihren mentalen Zustand.\n\nVORLAGE FÜR TAGEBUCHEINTRAG:\n\nDATUM: _______________\nEMOTIONALER ZUSTAND VOR DEM TRADING (1-10): ___\nNotizen: _______________\n\nTRADE\n• Paar: ___ — Richtung: LONG / SHORT\n• Analyse-Timeframe: ___\n• Einstiegsgrund: _______________\n• Identifiziertes Setup: _______________\n• Einstieg: ___  ·  SL: ___  ·  TP: ___\n• Berechnetes R:R: ___\n\nTRADE-MANAGEMENT\n• Hast du den Plan befolgt? JA / NEIN\n• Falls nein: Warum? _______________\n• Emotionen während des Trades: _______________\n\nERGEBNIS\n• Ausstiegspreis: ___  ·  P&L: ___\n• Hast du den SL respektiert? JA / NEIN\n• Hast du den TP respektiert? JA / NEIN\n\nLEKTION AUS DEM TRADE\n• Was hast du gut gemacht? _______________\n• Was würdest du verbessern? _______________\n\nWiederhole dies bei jeder Operation. Nach 50 Trades werden die Muster, die dein Konto zerstören, offensichtlich. Und dann kannst du sie korrigieren."
  }
];
